<template>
  <div
    class="text-link-list-container"
    :class="[
      { 'text-link-list-container--border': border },
      'text-link-list-container--' + backgroundColor
    ]"
  >
    <a
      class="text-link-list__link"
      :class="{ 'text-link-list__link--thin': thin }"
      :href="href"
    >
      <span
        class="text-link-list__text"
        :class="{
          'text-link-list__text--bold': bold,
          'text-link-list__text--has-chevron': hasChevron
        }"
      >
        {{ text }}
      </span>
      <ChevronRight
        v-if="hasChevron"
        :class="'text-link-list__chevron--right--' + chevronColor"
      />
    </a>
  </div>
</template>
<script>
import ChevronRight from '../../atoms/svg_icons/ChevronRight'
export default {
  components: { ChevronRight },
  props: {
    border: {
      type: Boolean,
      required: false,
      default: false
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'white'
    },
    href: {
      type: String,
      required: true
    },
    thin: {
      type: Boolean,
      required: false,
      default: false
    },
    bold: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    hasChevron: {
      type: Boolean,
      required: false,
      default: true
    },
    chevronColor: {
      type: String,
      required: false,
      default: 'black'
    }
  }
}
</script>
<style lang="scss" scoped>
.text-link-list-container {
  &--border {
    border-bottom: 1px solid $gray-2;
  }

  &--white {
    background-color: $white;
  }

  &--gray-3 {
    background-color: $gray-3;
  }

  .text-link-list {
    &__link {
      height: 56px;
      padding: 16px 12px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:hover {
        opacity: 0.7;
      }

      &--thin {
        height: 48px;
        padding: 14.5px 12px;

        .text-link-list__text {
          @extend %caption-black;

          &--bold {
            @extend %caption-bold;
            color: $black;
          }
        }
      }
    }

    &__text {
      @extend %body;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &--bold {
        @extend %body-bold;
      }

      &--has-chevron {
        width: calc(100% - 28px);
        margin-right: 4px;
      }
    }

    &__chevron--right {
      &--black {
        fill: $black;
      }
      &--link {
        fill: $link;
      }
    }
  }
}
</style>
